var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiminuerLumiere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 73.989 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 957",
    d: "M73.991 65.999H59.734v-4h10.257V42.785a29.2 29.2 0 0 0-2.639-12.023c-2.013-4.131-4.934-6.647-8.681-7.48l.868-3.9a15.285 15.285 0 0 1 7 3.611 19.546 19.546 0 0 1 4.413 6.021 33.3 33.3 0 0 1 3.039 13.732v23.253Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 958",
    d: "M56.932 0a9.954 9.954 0 0 1 6.878 2.743l.04.039a9.794 9.794 0 0 1 0 13.826l-2.282 2.282a1.919 1.919 0 0 0-.478 1.77 21.62 21.62 0 0 1-5.537 20.717l-1.414 1.429-30.356-30.35 1.43-1.414A21.637 21.637 0 0 1 45.945 5.5l.02.005a1.847 1.847 0 0 0 .489.066 1.867 1.867 0 0 0 1.319-.551l.01-.003 2.274-2.274A9.954 9.954 0 0 1 56.932 0Zm4.1 5.626a5.994 5.994 0 0 0-8.211 0l-2.208 2.215a5.893 5.893 0 0 1-4.159 1.735 5.848 5.848 0 0 1-1.537-.206 17.644 17.644 0 0 0-15.381 3.181l24.5 24.5a17.7 17.7 0 0 0 3.178-15.386l-.007-.028a5.907 5.907 0 0 1 1.5-5.545l.02-.02 2.292-2.292a5.8 5.8 0 0 0 .018-8.155Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 960",
    d: "M43.813 38.408 0 37.993l30.382-17.024 14.549 14.549Z",
    opacity: 0.33
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiminuerLumiere);
export default __webpack_public_path__ + "static/media/diminuer-lumiere.87ab69f808caa685ce4e94fa1e188254.svg";
export { ForwardRef as ReactComponent };